import api from './connectionProxy'
import { formatContentSelectValue } from '../utils'

export const getCids = (params = {}) => {
  const { page = 0, perPage = 50, order = {}, term = '' } = params

  return api.http.get('/cids', {
    params: {
      page,
      per_page: perPage,
      column: ((order || {}).column || ''),
      direction: ((order || {}).direction || 1),
      term
    }
  })
}

export const getCid = id => {
  return api.http.get(`/cids/${id}`)
}

export const searchCids = term => {
  return api.http.get('/cids/select_search', {
    params: {
      term
    }
  })
}

export const getSelectCids = (term, callback) => {
  searchCids(term).then(response => {
    const { data } = response
    const options = formatContentSelectValue(data)
    callback(null, {
      options,
      complete: true
    })
  })
}

export const deleteCid = id => {
  return api.http.delete(`/cids/${id}`)
}

export const restoreCid = id => {
  return api.http.put(`/cids/${id}/restore`)
}

export const editCid = cid => {
  return api.http.put(`/cids/${cid.cid._id}`, cid)
}

export const addCid = cid => {
  return api.http.post('/cids', cid)
}



// WEBPACK FOOTER //
// ./src/api/cids.js